function encodePathSegment(segment: string): string {
  try {
    return encodeURIComponent(decodeURIComponent(segment));
  } catch {
    return encodeURIComponent(segment);
  }
}

export function buildMediaPath(input: string): string {
  const segments = input
    .replace(/^\/+/, "")
    .split("/")
    .filter(Boolean)
    .map(encodePathSegment);

  return `/${segments.join("/")}`;
}
